(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bascar-aankondiging"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bx-announce]').forEach(function (root) {
      if (root.dataset.bxReady === 'true') return;
      root.dataset.bxReady = 'true';

      var inner = root.querySelector('[data-bx-announce-inner]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-bx-announce-item]'));
      if (!items.length) return;

      var desktop = window.matchMedia('(min-width: 990px)');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      var perView = parseInt(root.dataset.perView, 10) || 3;
      var delay = (parseInt(root.dataset.interval, 10) || 4) * 1000;
      var rotate = root.dataset.rotate === 'true';
      var page = 0;
      var timer = null;

      function per() {
        return desktop.matches ? perView : 1;
      }

      function pages() {
        return Math.ceil(items.length / per());
      }

      /* Toont de beloftes van de huidige pagina: op desktop een groep
         naast elkaar, op mobiel één tegelijk. */
      function show() {
        var p = per();
        page = page % pages();
        items.forEach(function (item, i) {
          item.classList.toggle('is-on', Math.floor(i / p) === page);
        });
      }

      function step() {
        inner.classList.add('is-fading');
        window.setTimeout(function () {
          page += 1;
          show();
          inner.classList.remove('is-fading');
        }, 250);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (!rotate || reduced.matches || pages() < 2) return;
        timer = window.setInterval(step, delay);
      }

      desktop.addEventListener('change', function () {
        page = 0;
        show();
        start();
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      show();
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bascar-combineer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initLook(root) {
      var look = root.querySelector('[data-bcomb-look]');
      if (!look || look.dataset.bxReady === 'true') return;
      look.dataset.bxReady = 'true';

      var spots = look.querySelectorAll('[data-bcomb-spot]');

      function sluit() {
        spots.forEach(function (spot) {
          spot.setAttribute('aria-expanded', 'false');
          var pop = document.getElementById(spot.getAttribute('aria-controls'));
          if (pop) pop.hidden = true;
        });
      }

      spots.forEach(function (spot) {
        spot.addEventListener('click', function (event) {
          event.stopPropagation();
          var open = spot.getAttribute('aria-expanded') === 'true';
          sluit();
          if (open) return;
          spot.setAttribute('aria-expanded', 'true');
          var pop = document.getElementById(spot.getAttribute('aria-controls'));
          if (pop) pop.hidden = false;
        });
      });

      /* Esc of een klik buiten het kaartje sluit het. */
      document.addEventListener('click', function (event) {
        if (event.target.closest && event.target.closest('[data-bcomb-pop]')) return;
        if (!look.contains(event.target)) sluit();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var open = look.querySelector('[data-bcomb-spot][aria-expanded="true"]');
        sluit();
        if (open) open.focus();
      });
    }

    function initAll() {
      document.querySelectorAll('[data-bcomb]').forEach(initLook);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bascar-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bx-header]').forEach(function (root) {
      if (root.dataset.bxReady === 'true') return;
      root.dataset.bxReady = 'true';

      var isRound = root.dataset.round === 'true';
      var hideOnScroll = root.dataset.hideOnScroll === 'true';
      var hover = window.matchMedia('(hover: hover) and (min-width: 990px)');
      var desktop = window.matchMedia('(min-width: 990px)');

      /* ---------- mega-menu ---------- */

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-bx-mega-item]'));

      function setOpen(item, open) {
        var trigger = item.querySelector('[data-bx-mega-trigger]');
        var panel = item.querySelector('[data-bx-mega]');
        if (!trigger || !panel) return;
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
        item.classList.toggle('is-open', open);
        if (!open) item.bxHoverOpened = false;
        root.classList.toggle('is-mega-open', items.some(function (i) {
          return i.classList.contains('is-open');
        }));
      }

      function closeAll(except) {
        items.forEach(function (item) {
          if (item !== except) setOpen(item, false);
        });
      }

      items.forEach(function (item) {
        var trigger = item.querySelector('[data-bx-mega-trigger]');
        var openTimer = null;
        var closeTimer = null;

        item.addEventListener('mouseenter', function () {
          if (!hover.matches) return;
          window.clearTimeout(closeTimer);
          openTimer = window.setTimeout(function () {
            closeAll(item);
            setOpen(item, true);
            item.bxHoverOpened = true;
          }, 150);
        });

        item.addEventListener('mouseleave', function () {
          if (!hover.matches) return;
          window.clearTimeout(openTimer);
          closeTimer = window.setTimeout(function () {
            setOpen(item, false);
          }, 200);
        });

        trigger.addEventListener('click', function () {
          var open = trigger.getAttribute('aria-expanded') === 'true';
          /* Net geopend door de muis: een klik laat het paneel open. */
          if (open && item.bxHoverOpened) {
            item.bxHoverOpened = false;
            return;
          }
          closeAll(item);
          setOpen(item, !open);
        });

        item.addEventListener('focusout', function (e) {
          if (e.relatedTarget && !item.contains(e.relatedTarget)) setOpen(item, false);
        });
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) closeAll();
      });

      /* ---------- mobiele menulade ---------- */

      var drawer = root.querySelector('[data-bx-drawer]');
      var opener = root.querySelector('[data-bx-drawer-open]');
      var hideTimer = null;

      function openDrawer() {
        if (!drawer) return;
        window.clearTimeout(hideTimer);
        drawer.hidden = false;
        root.classList.add('is-drawer-open');
        root.classList.remove('is-hidden');
        opener.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        window.requestAnimationFrame(function () {
          drawer.classList.add('is-open');
          var close = drawer.querySelector('button[data-bx-drawer-close]');
          if (close) close.focus();
        });
      }

      function closeDrawer(returnFocus) {
        if (!drawer || drawer.hidden) return;
        drawer.classList.remove('is-open');
        root.classList.remove('is-drawer-open');
        opener.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        hideTimer = window.setTimeout(function () {
          drawer.hidden = true;
        }, 300);
        if (returnFocus) opener.focus();
      }

      if (opener && drawer) {
        opener.addEventListener('click', openDrawer);
        drawer.querySelectorAll('[data-bx-drawer-close]').forEach(function (el) {
          el.addEventListener('click', function () {
            closeDrawer(true);
          });
        });
        desktop.addEventListener('change', function () {
          if (desktop.matches) closeDrawer(false);
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var openItem = root.querySelector('[data-bx-mega-item].is-open');
        if (openItem) {
          setOpen(openItem, false);
          openItem.querySelector('[data-bx-mega-trigger]').focus();
        }
        closeDrawer(true);
      });

      /* ---------- gedrag bij scrollen ---------- */

      var lastY = window.scrollY;
      var ticking = false;

      function busy() {
        return root.classList.contains('is-drawer-open') || !!root.querySelector('[data-bx-mega-item].is-open');
      }

      function update() {
        var y = window.scrollY;
        ticking = false;

        /* Bovenaan een afgerond paneel, na 40px scrollen een vaste balk. */
        if (isRound) root.classList.toggle('is-bar', y > 40);

        /* Standaard blijft de balk altijd in beeld (sticky). */
        if (!hideOnScroll) return;
        if (Math.abs(y - lastY) < 6) return;
        if (y > lastY && y > 160 && !busy()) {
          root.classList.add('is-hidden');
        } else if (y < lastY || y <= 160) {
          root.classList.remove('is-hidden');
        }
        lastY = y;
      }

      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(update);
        },
        { passive: true }
      );

      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bascar-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Uitklapblokken: er staat er steeds één open. Openen en sluiten
       glijden vloeiend; wie minder beweging wil, krijgt het direct. */
    function initUitklap(root) {
      var blokken = Array.prototype.slice.call(root.querySelectorAll('[data-bprod-blok]'));
      if (!blokken.length) return;

      var rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
      var gemak = 'cubic-bezier(0.2, 0, 0, 1)';

      function sluit(blok) {
        var inhoud = blok.querySelector('.bprod__blok-inhoud');
        blok.classList.remove('is-open');
        if (blok._anim) blok._anim.cancel();
        if (rustig.matches || !inhoud.animate) {
          blok.open = false;
          return;
        }
        blok._sluiten = true;
        var anim = inhoud.animate(
          [{ height: inhoud.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: 280, easing: gemak, fill: 'forwards' }
        );
        blok._anim = anim;
        /* Ook met een timer afronden: in een tabblad op de achtergrond
           loopt de animatie niet door en komt onfinish nooit. */
        function klaar() {
          if (blok._anim !== anim) return;
          blok.open = false;
          blok._sluiten = false;
          blok._anim = null;
          anim.cancel();
        }
        anim.onfinish = klaar;
        setTimeout(klaar, 320);
      }

      function open(blok) {
        var inhoud = blok.querySelector('.bprod__blok-inhoud');
        if (blok._anim) blok._anim.cancel();
        blok._sluiten = false;
        blok.open = true;
        blok.classList.add('is-open');
        if (rustig.matches || !inhoud.animate) return;
        var anim = inhoud.animate(
          [{ height: '0px', opacity: 0 }, { height: inhoud.offsetHeight + 'px', opacity: 1 }],
          { duration: 340, easing: gemak }
        );
        blok._anim = anim;
        anim.onfinish = function () {
          if (blok._anim === anim) blok._anim = null;
        };
      }

      /* De foto staat sticky naast het koopblok, maar schuift mee zodra de
         kolom ernaast korter of langer wordt. Daarom krijgt de lijst vooraf
         de hoogte van het langste blok: wisselen verandert de kolom dan niet. */
      var lijst = blokken[0].parentElement;
      var breed = window.matchMedia('(min-width: 990px)');
      function reserveer() {
        var was = blokken.map(function (blok) { return blok.open; });
        var hoogste = 0;
        lijst.style.minHeight = '';
        /* Op mobiel staat de foto boven de tekst en is dit niet nodig. */
        if (!breed.matches) return;
        blokken.forEach(function (blok) {
          blokken.forEach(function (ander) { ander.open = ander === blok; });
          hoogste = Math.max(hoogste, lijst.offsetHeight);
        });
        blokken.forEach(function (blok, i) { blok.open = was[i]; });
        lijst.style.minHeight = hoogste + 'px';
      }
      reserveer();
      var wacht;
      window.addEventListener('resize', function () {
        clearTimeout(wacht);
        wacht = setTimeout(reserveer, 150);
      });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(reserveer);

      blokken.forEach(function (blok) {
        if (blok.open) blok.classList.add('is-open');
        blok.querySelector('summary').addEventListener('click', function (event) {
          event.preventDefault();
          if (blok.open && !blok._sluiten) {
            sluit(blok);
            return;
          }
          blokken.forEach(function (ander) {
            if (ander !== blok && ander.open && !ander._sluiten) sluit(ander);
          });
          open(blok);
        });
      });
    }

    function initProduct(root) {
      if (root.dataset.bprodReady === 'true') return;
      root.dataset.bprodReady = 'true';
      initUitklap(root);

      var dataEl = root.querySelector('[data-bprod-variants]');
      var variants = [];
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        variants = [];
      }

      var idInput = root.querySelector('[data-bprod-id]');
      var priceEl = root.querySelector('[data-bprod-price]');
      var exclEl = root.querySelector('[data-bprod-excl]');
      var labelEl = root.querySelector('[data-bprod-variant-label]');
      var addBtn = root.querySelector('button.bprod__add');
      var ctaLinks = root.querySelectorAll('[data-bprod-cta]');

      var bar = root.querySelector('[data-bprod-bar]');
      var barImg = root.querySelector('[data-bprod-bar-img]');
      var barVariant = root.querySelector('[data-bprod-bar-variant]');
      var barPrice = root.querySelector('[data-bprod-bar-price]');
      var barAdd = root.querySelector('[data-bprod-bar-add]');

      var mediaPerKleur = {};
      var mediaEl = root.querySelector('[data-bprod-media]');
      if (mediaEl) {
        try {
          mediaPerKleur = JSON.parse(mediaEl.textContent);
        } catch (e) {
          mediaPerKleur = {};
        }
      }

      var thumbsEl = root.querySelector('[data-bprod-thumbs]');

      function zetHoofdfoto(src, alt) {
        var hoofd = root.querySelector('[data-bprod-main-img]');
        if (!hoofd) return;
        hoofd.removeAttribute('srcset');
        hoofd.src = src;
        if (alt) hoofd.alt = alt;
        if (barImg) barImg.src = src;
      }

      function onThumbClick() {
        zetHoofdfoto(this.dataset.full);
        root.querySelectorAll('[data-bprod-thumb]').forEach(function (t) {
          t.removeAttribute('aria-current');
        });
        this.setAttribute('aria-current', 'true');
      }

      function bindThumbs() {
        root.querySelectorAll('[data-bprod-thumb]').forEach(function (thumb) {
          thumb.removeEventListener('click', onThumbClick);
          thumb.addEventListener('click', onThumbClick);
        });
      }

      /* Toont alleen de foto's die bij de gekozen houtsoort horen. Vindt hij
         er geen, bijvoorbeeld doordat de naam niet in de alt-tekst staat, dan
         valt hij terug op alle productfoto's. Zonder die terugval bleef de
         galerij van de vorige houtsoort staan. */
      function toonMediaVoor(kleur) {
        var lijst = mediaPerKleur[kleur];

        if (!lijst || !lijst.length) {
          lijst = mediaPerKleur['__alle__'] || [];
        }

        if (!lijst.length) return;

        zetHoofdfoto(lijst[0].full, lijst[0].alt);

        if (!thumbsEl) return;

        if (lijst.length < 2) {
          thumbsEl.hidden = true;
          return;
        }

        thumbsEl.hidden = false;
        thumbsEl.innerHTML = '';

        lijst.slice(0, 4).forEach(function (item, i) {
          var knop = document.createElement('button');
          knop.type = 'button';
          knop.setAttribute('data-bprod-thumb', '');
          knop.setAttribute('data-full', item.full);
          knop.setAttribute('aria-label', 'Foto ' + (i + 1));
          if (i === 0) knop.setAttribute('aria-current', 'true');

          var img = document.createElement('img');
          img.src = item.thumb;
          img.alt = item.alt || '';
          img.width = 200;
          img.height = 200;
          img.loading = 'lazy';

          knop.appendChild(img);
          thumbsEl.appendChild(knop);
        });

        bindThumbs();
      }

      root.querySelectorAll('[data-bprod-option]').forEach(function (input) {
        input.addEventListener('change', function () {
          var match = variants.filter(function (v) {
            return v.option1 === input.value;
          })[0];
          if (!match) return;

          if (idInput) idInput.value = match.id;

          /* Het bedrag van de gekozen houtsoort, in de weergave die de
             bezoeker heeft gekozen. Zonder die keuzeknop blijft het bedrag
             inclusief btw. */
          if (priceEl) {
            priceEl.innerHTML = match.price;
            if (match.cents != null) priceEl.setAttribute('data-btw-prijs', match.cents);
          }
          if (barPrice) {
            barPrice.innerHTML = match.price;
            if (match.cents != null) barPrice.setAttribute('data-btw-prijs', match.cents);
          }
          if (exclEl && match.cents != null) exclEl.setAttribute('data-btw-excl', match.cents);
          /* De prijs per m² staat in het koopblok en in de balk onderin. */
          if (match.cents != null) {
            root.querySelectorAll('[data-bprod-m2]').forEach(function (m2El) {
              var m2 = parseFloat(m2El.getAttribute('data-bprod-m2'));
              if (m2 > 0) m2El.setAttribute('data-btw-prijs', Math.round(match.cents / m2));
            });
          }
          if (window.BascarBtw) window.BascarBtw.pasToe(root);

          if (labelEl) labelEl.textContent = input.value;
          if (barVariant) barVariant.textContent = input.value;
          if (addBtn) addBtn.disabled = !match.available;
          if (barAdd) barAdd.disabled = !match.available;

          /* De knoppen naar de configurator dragen de gekozen houtsoort mee.
             Zonder dit blijven ze wijzen naar de houtsoort van bij het laden. */
          var kleur = input.value
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
          ctaLinks.forEach(function (link) {
            if (link.dataset.bprodCtaBase) {
              link.href = link.dataset.bprodCtaBase + '?kleur=' + kleur + '#configurator';
            }
          });

          toonMediaVoor(input.value);

          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        });
      });

      bindThumbs();

      /* Bij het laden meteen de foto's van de al gekozen houtsoort tonen. */
      var gekozen = root.querySelector('[data-bprod-option]:checked');
      if (gekozen) toonMediaVoor(gekozen.value);

      var qtyInput = root.querySelector('[data-bprod-qty-input]');
      root.querySelectorAll('[data-bprod-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var step = parseInt(btn.dataset.bprodQty, 10);
          var next = (parseInt(qtyInput.value, 10) || 1) + step;
          qtyInput.value = next < 1 ? 1 : next;
        });
      });

      /* De knop in de koopbalk doet hetzelfde als de knop in het koopblok. */
      if (barAdd && addBtn) {
        barAdd.addEventListener('click', function () {
          addBtn.click();
        });
      }

      /* Koopbalk: verschijnt zodra de koopknop uit beeld is en blijft dan
         over de rest van de pagina staan, ook op de homepage. Hij verdwijnt
         alleen als de voettekst in beeld komt. */
      var mainCta = root.querySelector('[data-bprod-main-cta]');
      if (!bar || !mainCta || !('IntersectionObserver' in window)) return;

      var mobiel = window.matchMedia('(max-width: 749px)');

      /* De vaste kopbalk en de aankondiging bovenin liggen over de pagina.
         Een knop die daarachter zit, telt als uit beeld. */
      var rootStijl = getComputedStyle(document.documentElement);
      var kopHoogte =
        (parseFloat(rootStijl.getPropertyValue('--header-height')) || 0) +
        (parseFloat(rootStijl.getPropertyValue('--bascar-announcement-h')) || 0);
      var ctaInBeeld = true;
      var ctaVoorbij = false;
      var sectieInBeeld = false;
      var voetInBeeld = false;

      function toonBalk() {
        var weg = !ctaInBeeld && !voetInBeeld;
        var zichtbaar;
        if (mobiel.matches) {
          zichtbaar = weg && (sectieInBeeld || ctaVoorbij);
        } else {
          zichtbaar = weg && ctaVoorbij;
        }
        bar.classList.toggle('is-visible', zichtbaar);
        bar.setAttribute('aria-hidden', zichtbaar ? 'false' : 'true');

        /* De pagina weet hoe hoog de balk is. Springt de bezoeker naar een
           anker of tabt hij naar een veld, dan komt dat boven de balk te
           staan in plaats van erachter. */
        var html = document.documentElement;
        if (zichtbaar) {
          html.style.setProperty('--bprod-balk-h', bar.offsetHeight + 'px');
        }
        html.classList.toggle('bprod-balk-aan', zichtbaar);

        /* Bewust geen 'inert' meer: dat liet de balk soms zichtbaar maar
           onklikbaar achter. Verborgen is hij nu via de stijl (visibility
           en pointer-events), die altijd gelijk oploopt met wat u ziet. */
        bar.removeAttribute('inert');
      }

      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          ctaInBeeld = entry.isIntersecting;
          ctaVoorbij = entry.boundingClientRect.top < kopHoogte;
        });
        toonBalk();
      }, { rootMargin: '-' + Math.round(kopHoogte) + 'px 0px 0px 0px' }).observe(mainCta);

      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sectieInBeeld = entry.isIntersecting;
        });
        toonBalk();
      }).observe(root);

      var voet = document.querySelector('.bx-footer, .shopify-section-group-footer-group, footer');
      if (voet) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            voetInBeeld = entry.isIntersecting;
          });
          toonBalk();
        }).observe(voet);
      }

      if (mobiel.addEventListener) mobiel.addEventListener('change', toonBalk);
    }

    function initAll() {
      document.querySelectorAll('.bprod').forEach(initProduct);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bascar-productgrid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGrid(root) {
      if (root.dataset.bxReady === 'true') return;
      root.dataset.bxReady = 'true';

      /* Een klik op een houtsoort wisselt de foto, zonder de pagina te
         verlaten. */
      root.querySelectorAll('.bgrid__swatches').forEach(function (group) {
        group.addEventListener('click', function (event) {
          var knop = event.target.closest('[role="radio"]');
          if (!knop) return;
          event.preventDefault();
          group.querySelectorAll('[role="radio"]').forEach(function (x) {
            x.setAttribute('aria-checked', x === knop ? 'true' : 'false');
          });
          var src = knop.getAttribute('data-bgrid-swap');
          var card = group.closest('.bgrid__card');
          var img = card ? card.querySelector('.bx-card__media img') : null;
          if (src && img) {
            img.removeAttribute('srcset');
            img.src = src;
          }
        });
      });

      var track = root.querySelector('[data-bgrid-track]');
      var nav = root.querySelector('[data-bgrid-nav]');
      var prev = root.querySelector('[data-bgrid-prev]');
      var next = root.querySelector('[data-bgrid-next]');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      /* Knoppen uit aan het begin en het eind; weg als alles al past. */
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        if (nav) nav.hidden = max <= 0;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-bgrid]').forEach(initGrid);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bascar-projecten"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bpj]').forEach(function (root) {
      if (root.dataset.bxReady === 'true') return;
      root.dataset.bxReady = 'true';

      var chips = root.querySelectorAll('[data-bpj-chip]');
      if (!chips.length) return;

      var allKey = root.getAttribute('data-bpj-all');
      var cards = root.querySelectorAll('[data-bpj-keys]');
      var empty = root.querySelector('[data-bpj-empty]');

      /* Eén chip tegelijk actief; het eerste filter (Alle) toont alles. */
      chips.forEach(function (chip, index) {
        chip.addEventListener('click', function () {
          var key = chip.getAttribute('data-bpj-chip');
          var showAll = key === allKey || index === 0;
          var shown = 0;

          chips.forEach(function (c) {
            c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
          });

          cards.forEach(function (card) {
            var keys = (card.getAttribute('data-bpj-keys') || '').split(' ');
            var match = showAll || keys.indexOf(key) !== -1;
            card.hidden = !match;
            if (match) shown += 1;
          });

          if (empty) empty.hidden = shown > 0;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bascar-rekenhulp-proef"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PANEEL_BREEDTE = 60;   /* cm */
    var PANEEL_LENGTE = 300;   /* cm */
    var KOPSE_TRIM = 1;        /* cm */
    var ZAAGSNEDE = 0.4;       /* cm */
    var DEUR_B = 90;
    var DEUR_H = 210;

    function lees(veld) {
      if (!veld) return null;
      var schoon = veld.value.replace(/[^\d]/g, '');
      if (schoon !== veld.value) veld.value = schoon;
      if (schoon === '') return null;
      var n = parseInt(schoon, 10);
      return isNaN(n) ? null : n;
    }

    /* De bovenrand als reeks punten. Bij een knik ligt het middelste punt op
       de gemeten plek, niet op een plek die wij eruit afleiden. */
    function bovenrand(w, hL, hR, knik) {
      if (!knik) return [[0, hL], [w, hR]];
      return [[0, hL], [knik.x, knik.h], [w, hR]];
    }

    function hoogteOp(punten, x) {
      for (var i = 0; i < punten.length - 1; i++) {
        var a = punten[i], b = punten[i + 1];
        if (x >= a[0] && x <= b[0]) {
          if (b[0] === a[0]) return Math.max(a[1], b[1]);
          return a[1] + ((b[1] - a[1]) * (x - a[0])) / (b[0] - a[0]);
        }
      }
      return punten[punten.length - 1][1];
    }

    /* Hoogste punt binnen één baan. Alleen de randen bekijken is niet genoeg:
       ligt de knik midden in een baan, dan zit het hoogste punt daar. */
    function hoogsteInBaan(punten, x0, x1) {
      var hoogste = Math.max(hoogteOp(punten, x0), hoogteOp(punten, x1));
      punten.forEach(function (p) {
        if (p[0] > x0 && p[0] < x1) hoogste = Math.max(hoogste, p[1]);
      });
      return hoogste;
    }

    function banen(punten, w) {
      var aantal = Math.ceil(w / PANEEL_BREEDTE);
      var uit = [];
      for (var i = 0; i < aantal; i++) {
        var x0 = i * PANEEL_BREEDTE;
        var x1 = Math.min((i + 1) * PANEEL_BREEDTE, w);
        uit.push(Math.round(hoogsteInBaan(punten, x0, x1) * 10) / 10);
      }
      return uit;
    }

    function panelenVoor(hoogtes) {
      var bruikbaar = PANEEL_LENGTE - KOPSE_TRIM;
      var rest = [];
      hoogtes.slice().sort(function (a, b) { return b - a; }).forEach(function (h) {
        var nodig = h + ZAAGSNEDE;
        for (var i = 0; i < rest.length; i++) {
          if (rest[i] >= nodig) { rest[i] -= nodig; return; }
        }
        rest.push(bruikbaar - nodig);
      });
      return rest.length;
    }

    function svg(punten, w, hoogtes) {
      var maxH = 0;
      punten.forEach(function (p) { if (p[1] > maxH) maxH = p[1]; });
      if (DEUR_H > maxH) maxH = DEUR_H;

      var gat = 40;
      var totaalB = w + gat + DEUR_B;
      var pad = 26;
      var vbB = totaalB + pad * 2;
      var vbH = maxH + pad * 2 + 22;

      function X(cm) { return pad + cm; }
      function Y(cm) { return pad + (maxH - cm); }

      var d = 'M ' + X(0) + ' ' + Y(0);
      punten.forEach(function (p) { d += ' L ' + X(p[0]) + ' ' + Y(p[1]); });
      d += ' L ' + X(w) + ' ' + Y(0) + ' Z';

      var s = '<svg viewBox="0 0 ' + vbB + ' ' + vbH + '" role="img" aria-label="Schets van uw wand">';

      /* banen, zodat zichtbaar is hoe de panelen verdeeld worden */
      for (var i = 1; i * PANEEL_BREEDTE < w; i++) {
        var bx = X(i * PANEEL_BREEDTE);
        s += '<line class="rhp__baan" x1="' + bx + '" y1="' + Y(0) + '" x2="' + bx + '" y2="' + Y(hoogteOp(punten, i * PANEEL_BREEDTE)) + '"/>';
      }

      s += '<path class="rhp__wand" d="' + d + '"/>';

      /* deur voor het gevoel van schaal */
      var dx = X(w + gat);
      s += '<rect class="rhp__deur" x="' + dx + '" y="' + Y(DEUR_H) + '" width="' + DEUR_B + '" height="' + DEUR_H + '"/>';
      s += '<circle class="rhp__deurknop" cx="' + (dx + DEUR_B - 12) + '" cy="' + Y(DEUR_H / 2) + '" r="3"/>';
      s += '<text class="rhp__schaal" x="' + (dx + DEUR_B / 2) + '" y="' + (Y(0) + 16) + '" text-anchor="middle">deur</text>';

      /* maten */
      s += '<text class="rhp__maat" x="' + X(w / 2) + '" y="' + (Y(0) + 16) + '" text-anchor="middle">' + w + ' cm</text>';
      s += '<text class="rhp__maat" x="' + (X(0) - 6) + '" y="' + Y(punten[0][1] / 2) + '" text-anchor="end">' + punten[0][1] + '</text>';
      var laatste = punten[punten.length - 1];
      s += '<text class="rhp__maat" x="' + (X(w) + 6) + '" y="' + Y(laatste[1] / 2) + '" text-anchor="start">' + laatste[1] + '</text>';

      if (punten.length === 3) {
        s += '<line class="rhp__stip" x1="' + X(punten[1][0]) + '" y1="' + Y(0) + '" x2="' + X(punten[1][0]) + '" y2="' + Y(punten[1][1]) + '"/>';
        s += '<text class="rhp__maat" x="' + X(punten[1][0]) + '" y="' + (Y(punten[1][1]) - 6) + '" text-anchor="middle">' + punten[1][1] + '</text>';
      }

      return s + '</svg>';
    }

    function zinVoor(w, punten) {
      var t = 'Uw wand is ' + w + ' cm breed, ';
      if (punten.length === 2 && punten[0][1] === punten[1][1]) {
        return t + 'overal ' + punten[0][1] + ' cm hoog.';
      }
      t += 'links ' + punten[0][1] + ' cm hoog en rechts ' + punten[punten.length - 1][1] + ' cm hoog';
      if (punten.length === 3) {
        t += ', met het hoogste punt van ' + punten[1][1] + ' cm op ' + punten[1][0] + ' cm vanaf de linkerhoek';
      }
      return t + '.';
    }

    function herbereken(root) {
      var v = function (naam) { return root.querySelector('[data-rhp-' + naam + ']'); };
      var breedte = v('breedte'), links = v('links'), rechts = v('rechts');
      var kh = v('knikhoogte'), ka = v('knikafstand');
      var knikvraag = v('knikvraag'), knikvelden = v('knikvelden');
      var leeg = v('leeg'), tekening = v('tekening'), zin = v('zin');
      var uitkomst = v('uitkomst'), fout = v('fout');

      function knikAan() {
        var g = root.querySelector('[data-rhp-knik]:checked');
        return g && g.value === 'ja';
      }

      function toonFout(t) {
        if (!fout) return;
        fout.hidden = !t;
        fout.textContent = t || '';
      }

      (function () {
        var w = lees(breedte), hL = lees(links), hR = lees(rechts);

        if (knikvraag) knikvraag.hidden = !(w && hL && hR);
        if (knikvelden) knikvelden.hidden = !(w && hL && hR && knikAan());

        if (!w || !hL || !hR) {
          if (leeg) leeg.hidden = false;
          if (tekening) tekening.hidden = true;
          if (zin) zin.hidden = true;
          if (uitkomst) uitkomst.hidden = true;
          toonFout('');
          return;
        }

        var knik = null;
        if (knikAan()) {
          var h = lees(kh), x = lees(ka);
          if (!h || !x) {
            toonFout('Vul de hoogte en de afstand van de knik in.');
            return;
          }
          if (x <= 0 || x >= w) {
            toonFout('De knik moet tussen de linker- en rechterhoek liggen, dus tussen 1 en ' + (w - 1) + ' cm.');
            return;
          }
          knik = { x: x, h: h };
        }

        var punten = bovenrand(w, hL, hR, knik);
        var hoogtes = banen(punten, w);
        var maxHoogte = Math.max.apply(null, hoogtes);

        if (maxHoogte > PANEEL_LENGTE - KOPSE_TRIM) {
          toonFout('Deze wand is hoger dan wij uit één paneel kunnen zagen (' + (PANEEL_LENGTE - KOPSE_TRIM) + ' cm).');
          return;
        }

        toonFout('');

        if (leeg) leeg.hidden = true;
        if (tekening) { tekening.hidden = false; tekening.innerHTML = svg(punten, w, hoogtes); }
        if (zin) { zin.hidden = false; zin.textContent = zinVoor(w, punten); }

        if (uitkomst) {
          uitkomst.hidden = false;
          v('banen').textContent = hoogtes.length;
          v('zaaghoogtes').textContent = hoogtes.join(' · ') + ' cm';
          var p = panelenVoor(hoogtes);
          v('panelen').textContent = p + (p === 1 ? ' paneel' : ' panelen');
        }
      })();
    }

    /* Luisteren op het document in plaats van op de velden zelf. Het script
       van een sectie wordt door Shopify soms geladen voordat de sectie op de
       pagina staat; koppel je dan aan de velden, dan gebeurt er bij het typen
       niets. Met deze opzet maakt de volgorde van laden niet uit. */
    function vanuit(doel) {
      if (!doel || !doel.closest) return null;
      return doel.closest('[data-rhp]');
    }

    document.addEventListener('input', function (e) {
      var root = vanuit(e.target);
      if (root) herbereken(root);
    });

    document.addEventListener('change', function (e) {
      var root = vanuit(e.target);
      if (root) herbereken(root);
    });

    function tekenAlles() {
      document.querySelectorAll('[data-rhp]').forEach(herbereken);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tekenAlles);
    } else {
      tekenAlles();
    }

    document.addEventListener('shopify:section:load', tekenAlles);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bascar-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-brev]').forEach(function (root) {
      if (root.dataset.bxReady === 'true') return;
      root.dataset.bxReady = 'true';

      var track = root.querySelector('[data-brev-track]');
      var prev = root.querySelector('[data-brev-prev]');
      var next = root.querySelector('[data-brev-next]');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      /* Knoppen grijs aan het begin en het eind van de rij. */
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bascar-vragen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bfaq]').forEach(function (root) {
      if (root.dataset.bxReady === 'true') return;
      root.dataset.bxReady = 'true';

      /* Uitklapbaar: er staat steeds één vraag open. Openen en sluiten
         glijden vloeiend; wie minder beweging wil, krijgt het direct.
         Bij Alle antwoorden open staat alles gewoon open. */
      if (root.hasAttribute('data-bfaq-een')) {
        var vragen = Array.prototype.slice.call(root.querySelectorAll('[data-bfaq-vraag]'));
        var rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
        var gemak = 'cubic-bezier(0.2, 0, 0, 1)';

        var sluit = function (vraag) {
          var inhoud = vraag.querySelector('.bfaq__inhoud');
          vraag.classList.remove('is-open');
          if (vraag._anim) vraag._anim.cancel();
          if (rustig.matches || !inhoud.animate) {
            vraag.open = false;
            return;
          }
          vraag._sluiten = true;
          var anim = inhoud.animate(
            [{ height: inhoud.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
            { duration: 280, easing: gemak, fill: 'forwards' }
          );
          vraag._anim = anim;
          /* Ook met een timer afronden: in een tabblad op de achtergrond
             loopt de animatie niet door en komt onfinish nooit. */
          var klaar = function () {
            if (vraag._anim !== anim) return;
            vraag.open = false;
            vraag._sluiten = false;
            vraag._anim = null;
            anim.cancel();
          };
          anim.onfinish = klaar;
          setTimeout(klaar, 320);
        };

        var open = function (vraag) {
          var inhoud = vraag.querySelector('.bfaq__inhoud');
          if (vraag._anim) vraag._anim.cancel();
          vraag._sluiten = false;
          vraag.open = true;
          vraag.classList.add('is-open');
          if (rustig.matches || !inhoud.animate) return;
          var anim = inhoud.animate(
            [{ height: '0px', opacity: 0 }, { height: inhoud.offsetHeight + 'px', opacity: 1 }],
            { duration: 340, easing: gemak }
          );
          vraag._anim = anim;
          anim.onfinish = function () {
            if (vraag._anim === anim) vraag._anim = null;
          };
        };

        vragen.forEach(function (vraag) {
          vraag.querySelector('summary').addEventListener('click', function (event) {
            event.preventDefault();
            if (vraag.open && !vraag._sluiten) {
              sluit(vraag);
              return;
            }
            vragen.forEach(function (ander) {
              if (ander !== vraag && ander.open && !ander._sluiten) sluit(ander);
            });
            open(vraag);
          });
        });
      }

      var chips = root.querySelectorAll('[data-bfaq-chip]');
      if (!chips.length) return;

      /* Eén chip tegelijk actief; Alle toont elke groep. */
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var key = chip.getAttribute('data-bfaq-chip');
          chips.forEach(function (c) {
            c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
          });
          root.querySelectorAll('[data-bfaq-group]').forEach(function (group) {
            group.hidden = key !== 'alle' && group.getAttribute('data-bfaq-group') !== key;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bascar-winkelwagen"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bcart__form').forEach(function (form) {
    if (form.dataset.bcartReady === 'true') return;
    form.dataset.bcartReady = 'true';

    var updateBtn = form.querySelector('[name="update"]');

    form.querySelectorAll('[data-bcart-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentNode.querySelector('[data-bcart-qty]');
        if (!input) return;
        var next = parseInt(input.value, 10) + parseInt(btn.dataset.bcartStep, 10);
        if (isNaN(next) || next < 0) next = 0;
        input.value = next;
        if (updateBtn) updateBtn.click();
      });
    });

    form.querySelectorAll('[data-bcart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (updateBtn) updateBtn.click();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
